import React, { useState } from 'react'
import { Button, Input, Select, Switch, Tooltip } from 'antd'
import ScheduleRow from './ScheduleRow'
import _ from 'lodash'
import { TAGS } from "../../../home/helpers/orderFilters.json"

function FormRule(props) {
    const {
        priority,
        validate,
        location,
        onChangeSelect,
        onlyStore,
        onChangeOnlyStore,
        onlyPackage,
        onChangeOnlyPackage,
        status,
        onChangeActive,
        products,
        allSku,
        stores,
        onChangeTagMode,
        tags,
        specialModes,
        isFit,
        onChangeIsFit,
        splitByPack,
        onChangeSplitByPack,
        isMultiVariants,
        onChangeMultiVariants,
        isMultiFrames,
        onChangeMultiFrames,
        onChangeInput,
        partner,
        allPartners,
        removeRecord,
        addCondition,
        onChangeRecord,
        errors,
        addFitCondition,
        removeFitCondition,
        handleDragEnd,
        onChangeMultiBrand,
        isMultiBrands,
        onAddSizeFrames,
        sizeFrames,
        sizeOfRawMaterials,
        onAddSizeRawMaterials,
        categories,
        listCategories,
        onAddSchedule,
        onChangeSchedules,
        schedules,
        setSchedules,
    } = { ...props }
    const [editingValue, setEditingValue] = useState("")

    const optionPartner = allPartners.filter(i => i.name === 'QUANG MINH' || i.name === 'BINH MINH' || i.name === 'TOÀN CẦU')

    const _handleChangeMultiVariants = (value) => {
        onChangeMultiVariants(value)
        setEditingValue('')
    }

    return (
        <div className="FormRule row" style={{ minHeight: '80vh' }}>
            <div className="col-4" style={{ borderRight: '1px dashed #bba8a8' }}>
                <div className="row mb-3">
                    <div className="Priority col-6 pl-0">
                        <label>Priority <span className="text-danger">*</span></label>
                        <Input
                            type="number"
                            className={(!!validate.priority && validate.priority.length > 0) ? 'Error' : ''}
                            value={priority || ''}
                            allowClear
                            onChange={(e) => onChangeInput('priority', e)}
                            placeholder="Nhập priority"
                        />
                        {
                            !!validate.priority && validate.priority.length > 0 &&
                            <small className="Validate">{validate.priority}</small>
                        }
                    </div>
                    <div className="Partner col-6 pl-0">
                        <label>Partner <span className="text-danger">*</span></label>
                        <Select
                            className={`${(!!validate.partner && validate.partner.length > 0) ? 'Error' : ''} w-100`}
                            name="partner"
                            placeholder="Chọn partner"
                            value={partner || []}
                            allowClear
                            onChange={(e) => onChangeSelect('partner', e)}
                        >
                            {!!optionPartner.length && optionPartner.map((i, index) => (
                                <Select.Option key={i._id} value={i._id}>{i.name}</Select.Option>
                            ))}
                        </Select>
                        {
                            !!validate.partner && validate.partner.length > 0 &&
                            <small className="Validate">{validate.partner}</small>
                        }
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="Location col-12 pl-0">
                        <label>Location</label>
                        <Select
                            className={`w-100`}
                            name="location"
                            placeholder="Chọn địa điểm sản xuất"
                            value={location || []}
                            allowClear
                            onChange={(e) => onChangeSelect('location', e)}
                        >
                            <Select.Option value={"QM"}>Quang Minh</Select.Option>
                            <Select.Option value={"SW"}>Đăng Quang</Select.Option>
                        </Select>
                    </div>
                </div>

                <div className="row mb-3 d-flex justify-content-between pr-3">
                    <div className="onlyStore d-flex align-items-center">
                        <label className="d-block mb-0">Only store</label>
                        <Switch checked={onlyStore} onChange={onChangeOnlyStore} className="ml-2" />
                    </div>
                    <div className="onlyPackage d-flex align-items-center">
                        <label className="d-block mb-0">Only package</label>
                        <Switch checked={onlyPackage} onChange={onChangeOnlyPackage} className="ml-2" />
                    </div>
                    {/* <div className="multiBrand d-flex align-items-center">
                        <Tooltip
                            title={isMultiBrands ? 'Lô tạo thành có thể chứa nhiều brands' : 'Lô tạo thành chỉ chứa 1 brand'}
                            className='d-flex align-items-center'
                        >
                            <label className="d-block mb-0">Brands</label>
                            <Switch checked={isMultiBrands} onChange={onChangeMultiBrand} className="ml-2" />
                        </Tooltip>
                    </div> */}
                    <div className="onlyPackage d-flex align-items-center">
                        <label className="d-block mb-0">Active</label>
                        <Switch checked={status} onChange={onChangeActive} className="ml-2" />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="Product col-12 pl-0">
                        <label className="d-block">Danh mục sản phẩm</label>
                        <div className="d-flex">
                            <Select defaultValue={'exclude'} value={categories.mode || 'exclude'}
                                style={{ width: '70px' }}
                                onChange={(e) => onChangeSelect('category-mode', e)}>
                                <Select.Option value={'include'}>Gồm</Select.Option>
                                <Select.Option value={'exclude'}>Trừ</Select.Option>
                            </Select>
                            <Select
                                className={`${(!!validate.sku && validate.sku.length > 0) ? 'Error' : ''} w-100 ml-2`}
                                mode="tags"
                                style={{ width: '100%' }}
                                showArrow={true}
                                placeholder="Chọn danh mục"
                                tokenSeparators={[',', ' ']}
                                value={categories.list}
                                allowClear
                                onChange={(e) => onChangeSelect('categories', e)}
                                disabled={products.mode === "include" && !!_.get(products, 'sku.length') && categories.mode === "exclude"}
                            >
                                {!!listCategories.length && listCategories.map((i, index) => (
                                    <Select.Option key={i._id} value={i._id}>{i.name}</Select.Option>
                                ))}
                            </Select>
                        </div>
                        {
                            !!validate.sku && validate.sku.length > 0 && <label className="Validate mb-0">{validate.sku}</label>
                        }
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="Product col-12 pl-0">
                        <label className="d-block">Products</label>
                        <div className="d-flex">
                            <Select defaultValue={'exclude'} value={products.mode || 'exclude'}
                                style={{ width: '70px' }}
                                onChange={(e) => onChangeSelect('product', e)}>
                                <Select.Option value={'include'}>Gồm</Select.Option>
                                <Select.Option value={'exclude'}>Trừ</Select.Option>
                            </Select>
                            <Select
                                className={`${(!!validate.sku && validate.sku.length > 0) ? 'Error' : ''} w-100 ml-2`}
                                mode="tags"
                                style={{ width: '100%' }}
                                showArrow={true}
                                placeholder="Chọn loại sản phẩm"
                                tokenSeparators={[',', ' ']}
                                value={products.sku}
                                allowClear
                                onChange={(e) => onChangeSelect('sku', e)}
                                disabled={categories.mode === "exclude" && !!_.get(categories, 'list.length') && products.mode === "include"}
                            >
                                {!!allSku.length && allSku.map((i, index) => (
                                    <Select.Option key={i._id} value={i.sku}>{i.sku}</Select.Option>
                                ))}
                            </Select>
                        </div>
                        {
                            !!validate.sku && validate.sku.length > 0 && <label className="Validate mb-0">{validate.sku}</label>
                        }
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="Stores col-12 pl-0">
                        <label className="d-block">Stores</label>
                        <div className="d-flex">
                            <Select
                                defaultValue={'exclude'}
                                style={{ width: '70px' }}
                                value={stores.mode || 'exclude'}
                                onChange={(e) => onChangeSelect('stores', e)}
                            >
                                <Select.Option value={'include'}>Gồm</Select.Option>
                                <Select.Option value={'exclude'}>Trừ</Select.Option>
                            </Select>
                            <Select
                                className={`${(!!validate.stores && validate.stores.length > 0) ? 'Error' : ''} w-100 ml-2`}
                                value={stores.list || []}
                                placeholder="Nhập stores"
                                mode="tags"
                                onChange={(value) => onChangeTagMode('stores', value)}
                                tokenSeparators={[',', ' ']}
                                allowClear
                                open={false}
                            />
                        </div>
                        {
                            !!validate.stores && validate.stores.length > 0 &&
                            <label className="Validate mb-0">{validate.stores}</label>
                        }
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="required_tags col-12 pl-0">
                        <label className="d-block">Tags</label>
                        <div className="d-flex">
                            <Select defaultValue={'exclude'} value={tags.mode || 'exclude'}
                                style={{ width: '130px' }}
                                onChange={(e) => onChangeSelect('tags', e)}>
                                <Select.Option value={'include'}>Gồm</Select.Option>
                                <Select.Option value={'exclude'}>Trừ</Select.Option>
                                <Select.Option value={'Dlican'}>Dlican</Select.Option>
                                <Select.Option value={'force_cmyk'}>Force CMYK</Select.Option>
                            </Select>
                            {!specialModes.includes(tags.mode) && (
                                <Select
                                    className={`${(!!validate.tags && validate.tags.length > 0) ? 'Error' : ''} w-100 ml-2`}
                                    value={tags.tags || []}
                                    placeholder="Nhập tags"
                                    tokenSeparators={[',', ' ']}
                                    mode="multiple"
                                    onChange={(value) => onChangeTagMode('tags', value)}
                                    allowClear
                                >
                                    {
                                        TAGS.map((i, index) => (
                                            <Select.Option value={i.value} key={index}>{i.label}</Select.Option>
                                        ))
                                    }
                                </Select>
                            )}
                        </div>
                        {
                            !!validate.tags && validate.tags.length > 0 &&
                            <label className="Validate mb-0">{validate.tags}</label>
                        }
                    </div>
                </div>
            </div>

            <div className="col-8" style={{ maxHeight: '700px', overflowY: 'auto' }}>
                <div className="row mb-4">
                    <div className="isFit d-flex" style={{ marginRight: '50px' }}>
                        <Switch
                            checked={isFit}
                            checkedChildren="Diện tích"
                            unCheckedChildren="Số lượng"
                            onChange={onChangeIsFit}
                            className={`ml-3 custom-switch ${isFit ? 'area-switch' : 'quantity-switch'}`}
                            disabled
                        />
                    </div>
                    {
                        isFit ?
                            <div className="d-flex">
                                <div className="splitByPack d-flex" style={{ marginRight: '50px' }}>
                                    <label className="d-block mb-0">Tách theo pack</label>
                                    <Switch checked={splitByPack} onChange={onChangeSplitByPack} className="ml-3" />
                                </div>
                            </div> :
                            <>
                                <div className="d-flex">
                                    <div className="isMultiVariants d-flex align-items-center" style={{ marginRight: '50px' }}>
                                        <label className="d-block mb-0">Variant</label>
                                        <Switch checked={isMultiVariants} onChange={_handleChangeMultiVariants} className="ml-3" />
                                    </div>
                                </div>
                                {/* {
                                    isMultiVariants &&
                                    <div className="d-flex align-items-center">
                                        <div className="isMultiFrames d-flex" style={{ marginRight: '50px' }}>
                                            <label className="d-block mb-0">Lưới</label>
                                            <Switch checked={isMultiFrames} onChange={onChangeMultiFrames} className="ml-3" />
                                        </div>
                                    </div>
                                } */}
                            </>
                    }
                </div>

                {
                    schedules.map(scheduleItem => {
                        return (
                            <ScheduleRow
                                key={scheduleItem.idx}
                                scheduleItem={scheduleItem}
                                validate={validate}
                                onChangeSchedules={onChangeSchedules}
                                isMultiVariants={isMultiVariants}
                                isFit={isFit}
                                allPartners={allPartners}
                                isMultiFrames={isMultiFrames}
                                handleDragEnd={handleDragEnd}
                                sizeFrames={sizeFrames}
                                optionPartner={optionPartner}
                                setSchedules={setSchedules}
                                addCondition={addCondition}
                                onChangeRecord={onChangeRecord}
                                onAddSizeFrames={onAddSizeFrames}
                                removeRecord={removeRecord}
                                addFitCondition={addFitCondition}
                                removeFitCondition={removeFitCondition}
                                schedules={schedules}
                                sizeOfRawMaterials={sizeOfRawMaterials}
                                onAddSizeRawMaterials={onAddSizeRawMaterials}
                                editingValue={editingValue}
                                setEditingValue={setEditingValue}
                            />
                        )
                    })
                }
                <Button className='mt-1' type="primary" onClick={onAddSchedule}>Thêm schedule</Button>
            </div>

            {
                errors && <div className="ValidateError">
                    {
                        errors.split("\n").map((e, index) => <p key={index}>{e}</p>)
                    }
                </div>
            }
        </div>
    )
}

export default FormRule